import React from 'react'
import { Row, Col, FormGroup, Input, Button, Label } from 'reactstrap'
import { isEmpty } from 'lodash'
import CurrencyFormat from 'react-currency-format'

const Summary = ({
  title,
  cart,
  loading,
  couponCode,
  setCouponCode,
  applyCoupon,
  couponDetail,
  showCouponDiscount,
}) => {
  return (
    <React.Fragment>
      <div className="cart-card">
        <Row>
          <h3 className="cart-card-title">{isEmpty(title) ? 'Desgloce de Precios' : title}</h3>
        </Row>
        <Row style={{ marginBottom: '10px' }}>
          <Col
            className="text-left cart-card-font"
            style={{ alignSelf: 'center' }}
          >
            Productos
          </Col>
          <Col
            className="text-right cart-card-font"
            style={{ alignSelf: 'center' }}
          >
            <CurrencyFormat
              value={cart.subtotal}
              displayType="text"
              thousandSeparator
              decimalScale={2}
              prefix="$"
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: '10px' }}>
          <Col
            className="text-left cart-card-font"
            style={{ alignSelf: 'center' }}
          >
            Envío
          </Col>
          <Col
            className="text-right cart-card-font"
            style={{ alignSelf: 'center' }}
          >
            $ {cart.supplier.costoEnvioEstandar.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </Col>
        </Row>
        <div
          style={{
            marginTop: '20px',
            marginBottom: '20px',
            borderBottom: '.1rem solid #cccccc'
          }}
        >
        </div>
        <Row style={{ marginBottom: '10px' }}>
          <Col
            className="text-left cart-card-font"
            style={{ alignSelf: 'center' }}
          >
            <div className="cart-summary-card-total">
              Subtotal
            </div>
          </Col>
          <Col
            className="text-right cart-card-font cart-summary-card-total"
            style={{ alignSelf: 'center', fontWeight: 500 }}
          >
            $ {(cart.total).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </Col>
        </Row>
        {cart.discount !== '0' && (
          <Row style={{ marginBottom: '10px' }}>
            <Col
              className="text-left cart-card-font"
              style={{ alignSelf: 'center' }}
            >
              <div className="cart-summary-card-total">
                Descuento
              </div>
            </Col>
            <Col
              className="text-right cart-card-font cart-summary-card-total"
              style={{ alignSelf: 'center', fontWeight: 500 }}
            >
              - $ {cart.discount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </Col>
          </Row>
        )}
        <Row style={{ marginBottom: '32px' }}>
          <Col
            className="text-left cart-card-font"
            style={{ alignSelf: 'center', fontSize: '16px' }}
          >
            <div className="cart-summary-card-total">
              Total a Pagar
            </div>
          </Col>
          <Col
            className="text-right cart-card-font cart-summary-card-total"
            style={{ alignSelf: 'center', fontWeight: 500, fontSize: '16px' }}
          >
            $ {(cart.total - cart.discount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </Col>
        </Row>
        <Row style={{ marginBottom: '10px' }}>
          <Col
            className="text-left cart-card-font"
            style={{ alignSelf: 'center' }}
          >
            <div className="cart-summary-card-price">
              Precio Sugerido
            </div>
          </Col>
          <Col
            className="text-right cart-card-font cart-summary-card-price"
            style={{ alignSelf: 'center', fontWeight: 500 }}
          >
            $ {(cart.retailTotal).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </Col>
        </Row>
        <Row>
          <Col
            className="text-left cart-card-font"
            style={{ alignSelf: 'center' }}
          >
            <div className="cart-summary-card-profit">
              Tu Posible Ganancia
            </div>
          </Col>
          <Col
            className="text-right cart-card-font cart-summary-card-profit"
            style={{ alignSelf: 'center', fontWeight: 500 }}
          >
            $ {((cart.retailTotal - cart.total) + parseFloat(cart.discount)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </Col>
        </Row>
      </div>
      {showCouponDiscount && (
        <div className="cart-card">
          <Row>
            <Col xs={6} sm={6}>
                <FormGroup>
                    <Label>
                        ¿Tienes un código de descuento?
                    </Label>

                    <Input
                        type="text"
                        name="discountCode"
                        id="discountCode"
                        className="StripeElement input-like-stripe"
                        required
                        value={couponCode}
                        placeholder="Escribe el código de descuento..."
                        onChange={(event) => {
                            setCouponCode(event.target.value.toUpperCase())
                        }}
                    />
                </FormGroup>
            </Col>
            <Col xs={6} sm={6}>
                <FormGroup>
                    <Label>&nbsp;</Label>
                    <Button
                        style={{ marginTop: '34px'}}
                        onClick={() => { 
                            window.analytics.track("Validate coupon", {
                                couponCode
                            })

                            applyCoupon() 
                        }}
                        color="primary"
                        className="btn btn-success waves-effect waves-light mb-2 mr-2"
                        disabled={isEmpty(couponCode) || loading}
                        >
                    Validar cupón
                  </Button>
                </FormGroup>
            </Col>
          </Row>
          {!isEmpty(couponDetail) && (
            <Row>
              <Col sm="12" className="cart-summary-card-profit" style={{ width: '100%', fontSize: '10px' }}>
                <label>
                  {`${couponDetail.name}. ${couponDetail.description}`}
                </label>
              </Col>
            </Row>
          )}
        </div>
      )}
    </React.Fragment>
  )
}

Summary.defaultProps = {
  showCouponDiscount: true
}

export default Summary
